import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'Ter plaatse',
      [RoomServiceLocationType.TableService]: 'Ter plaatse',
      both: 'Ter plaatse',
    },
    [ORDER_METHODS.PICKUP]: 'Afhalen',
    [ORDER_METHODS.DELIVERY]: 'Bezorging',
  },
};
